<section class="section bg-blue-extra-light1">
  <dashboard-customers-summary [data]="summary"></dashboard-customers-summary>
  <dashboard-customers-deviations [deviations]="deviations"></dashboard-customers-deviations>
  <dashboard-customers-list [customers]="list"></dashboard-customers-list>
</section>
